import React, { FC, useState } from "react";
import { ToggleButton } from "src/components/ToggleButton";
import { Packeges } from "./Packeges";
import { FolderWrapper } from "../FolderWrapper";
import { SECTION_IDS } from "../constants";
import { IOptionSelect } from "src/@types/form";
import { BUTTONS } from "src/components/ToggleButton/constants";

export const ServicePackagesSection: FC = () => {
  const [selectOption, setSelectOption] = useState<IOptionSelect>(BUTTONS[0]);

  return (
    <FolderWrapper
      title="Пакети"
      titleClassName="!bg-green-base text-white-base"
      className="bg-green-gradient flex flex-col gap-6 xl:gap-15 px-7 py-9 2xl:px-31 2xl:py-18"
      id={SECTION_IDS.SERVICE_PACKAGES}
    >
      <ToggleButton
        selectOption={selectOption}
        setSelectOption={setSelectOption}
      />
      <Packeges selectOption={selectOption} />
    </FolderWrapper>
  );
};
